var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",class:_vm.classnames,attrs:{"id":_vm.id+_vm._uid,"contenteditable":"true","value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }